import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IGetChannelLLMTemplateDTO,
  IGetChannelLLMTemplateResponse,
  IUpdateChannelLLMTemplateDTO,
  IUpdateChannelLLMTemplateResponse,
  IResetChannelLLMTemplateDTO,
  IResetChannelLLMTemplateResponse,
} from '@/models/llmTemplate.model';
import { IApiError } from '@/models/apiError.model';
import { formatApiError } from '@/utils';
import { LLMTemplateAPI } from '@/api';
import { SLICE_NAME } from './models';

export const getChannelLLMTemplate = createAsyncThunk<
  IGetChannelLLMTemplateResponse,
  IGetChannelLLMTemplateDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getChannelLLMTemplate`,
  async (params) => {
    const response = await LLMTemplateAPI.getChannelTemplate(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateChannelLLMTemplate = createAsyncThunk<
  IUpdateChannelLLMTemplateResponse,
  IUpdateChannelLLMTemplateDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateChannelLLMTemplate`,
  async (data) => {
    const response = await LLMTemplateAPI.updateChannelTemplate(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const resetChannelLLMTemplate = createAsyncThunk<
  IResetChannelLLMTemplateResponse,
  IResetChannelLLMTemplateDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/resetChannelLLMTemplate`,
  async (data) => {
    const response = await LLMTemplateAPI.resetChannelTemplate(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
